import { useTranslation } from "react-i18next";
import { TextField } from "@mui/material";
import React, { FC } from "react";

import { Stack, Typography } from "@components/base";
import { useQuestionEditorStore } from "@components/main/questions/QuestionEditor";

interface QuestionId {}

const QuestionId: FC<QuestionId> = () => {
  const { newQuestionConfig } = useQuestionEditorStore();
  const { t } = useTranslation();

  return (
    <Stack mt={2} mb={2} spacing={1}>
      <Typography variant="body2" sx={{ fontWeight: 500 }}>
        {t("questionEditor.idLabel")}
      </Typography>
      <TextField value={newQuestionConfig?.id} variant="filled" fullWidth disabled />
    </Stack>
  );
};

export default QuestionId;
